<template>
    <div class="pa-ui pa-page rma-page">
        <header class="pa-page-header">
            <div class="pa-page-header__row">
                <div>
                    <h1 class="pa-title">Questionários</h1>
                    <p class="pa-subtitle">Questionários de fiscalização enviados pela Administração Judicial. Responda os pendentes; as respostas ficam registradas.</p>
                </div>
            </div>
        </header>

        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

        <div v-else-if="loadError" class="pa-card rma-qn-empty">
            <div class="pa-empty">
                <v-icon large>{{ loadError.blocked ? "mdi-lock-outline" : "mdi-alert-circle-outline" }}</v-icon>
                <div>{{ loadError.message }}</div>
                <v-btn v-if="!loadError.blocked" outlined small class="mt-4" @click="load">Tentar de novo</v-btn>
            </div>
        </div>

        <div v-else-if="!items.length" class="pa-card rma-qn-empty">
            <div class="pa-empty">
                <v-icon large>mdi-clipboard-list-outline</v-icon>
                <div>Nenhum questionário recebido até agora. Quando a Administração Judicial enviar, ele aparece aqui e chega por e-mail.</div>
            </div>
        </div>

        <div v-else class="rma-qn-list">
            <router-link v-for="item in items" :key="item.id" :to="`/fiscalizacao-mensal/questionarios/${item.id}`" class="pa-card rma-qn-card">
                <v-icon :color="item.status === 'sent' ? 'warning' : 'success'">{{ item.status === "sent" ? "mdi-clipboard-edit-outline" : "mdi-clipboard-check-outline" }}</v-icon>
                <div class="rma-qn-card__main">
                    <div class="rma-qn-card__title">{{ item.title }}</div>
                    <div class="rma-qn-card__meta">
                        Recebido em {{ formatDateTime(item.sent_at) }} · {{ item.questions }} pergunta(s)
                        <span v-if="item.due_date_label"> · responder até <strong>{{ item.due_date_label }}</strong></span>
                    </div>
                </div>
                <pa-badge :variant="item.status === 'sent' ? 'warning' : item.status === 'answered' ? 'success' : 'neutral'" :text="item.status === 'sent' ? 'Responder' : item.status_label" />
                <v-icon small>mdi-chevron-right</v-icon>
            </router-link>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { eventHub } from "@/main";
import PaBadge from "@/components/plan-adhesion/PaBadge.vue";
import { errorMessage, formatDateTime } from "@/components/rma/rma.util";
import "@/components/plan-adhesion/pa-ui.scss";

// Fiscalizacao mensal > Questionarios (Painel da Devedora).
export default {
    name: "RmaQuestionnaires",

    components: { PaBadge },

    data: () => ({ loading: true, loadError: null, items: [] }),

    created() {
        this.load();
        eventHub.$on("client-context-changed", this.load);
    },

    beforeDestroy() {
        eventHub.$off("client-context-changed", this.load);
    },

    methods: {
        formatDateTime,

        async load() {
            this.loading = true;
            this.loadError = null;
            try {
                const result = await axios.get("/api/client/rma/questionnaires");
                const list = result.data.content || [];
                // Pendentes primeiro.
                this.items = [...list.filter((row) => row.status === "sent"), ...list.filter((row) => row.status !== "sent")];
            } catch (error) {
                const status = error && error.response && error.response.status;
                this.loadError = status === 403
                    ? { blocked: true, message: errorMessage(error, "A fiscalização mensal não está ativa para este caso.") }
                    : { blocked: false, message: errorMessage(error, "Não foi possível carregar os questionários.") };
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.rma-qn-empty {
    padding: 24px;
}

.rma-qn-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.rma-qn-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    text-decoration: none;
    color: inherit;
    transition: box-shadow 0.15s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(43, 32, 80, 0.1);
    }
}

.rma-qn-card__main {
    flex: 1;
    min-width: 0;
}

.rma-qn-card__title {
    font-weight: 600;
    font-size: 15px;
}

.rma-qn-card__meta {
    font-size: 13px;
    color: #6b6880;
    margin-top: 2px;
}
</style>
